import React from "react";
import Link from "next/link";
import { Link as MuiLink, ButtonBase } from "@material-ui/core";

import { getPageSlug } from "./utils";
import useFilters from "hooks/useFilters";
import { makeStyles } from "@material-ui/styles";

export default function PaginatorItem({ item, children, onPageChange, ...rest }) {
  const [activeFilters, dispatch] = useFilters();
  const classes = useStyle();

  if (item.disabled || item.page === null) {
    return <li {...rest}>{children}</li>;
  }

  // Category SSG page
  if (
    !onPageChange &&
    Object.keys(activeFilters.filters).length === 1 &&
    activeFilters.filters.category &&
    activeFilters.filters.category !== "catalogue"
  ) {
    return (
      <li {...rest}>
        <Link
          href={{
            pathname: "/reconditionne/[category]",
            query: {
              category: getPageSlug(activeFilters.filters.category, item.page),
            },
          }}
          passHref
        >
          <MuiLink>{children}</MuiLink>
        </Link>
      </li>
    );
  }

  // Subcategory1 SSG page
  if (
    !onPageChange &&
    Object.keys(activeFilters.filters).length === 2 &&
    activeFilters.filters.category &&
    activeFilters.filters.subcategory1
  ) {
    return (
      <li {...rest}>
        <Link
          href={{
            pathname: "/reconditionne/[category]/[subcategory1]",
            query: {
              category: activeFilters.filters.category,
              subcategory1: getPageSlug(activeFilters.filters.subcategory1, item.page),
            },
          }}
          passHref
        >
          <MuiLink>{children}</MuiLink>
        </Link>
      </li>
    );
  }

  // Default to client side filtering
  return (
    <li {...rest}>
      <ButtonBase
        className={item.selected ? classes.buttonSelected : classes.button}
        onClick={() => {
          onPageChange ? onPageChange(item.page) : dispatch({ type: "setPage", page: item.page });
        }}
      >
        {children}
      </ButtonBase>
    </li>
  );
}

const useStyle = makeStyles((theme) => ({
  buttonSelected: {
    color: "white",
  },
  button: {
    color: theme.palette.secondary.main,
  },
}));
